import { render } from "./ApplicationCal.vue?vue&type=template&id=2f19bc7e&scoped=true"
import script from "./ApplicationCal.vue?vue&type=script&lang=js"
export * from "./ApplicationCal.vue?vue&type=script&lang=js"

import "./ApplicationCal.vue?vue&type=style&index=0&id=2f19bc7e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f19bc7e"]])

export default __exports__